"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const organization_json_1 = require("./organization-json");
exports.OrganizationDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Organization', organization_json_1.OrganizationJsonMapper);
